"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _misc = require("../../../misc");

var _atoms = require("../../../atoms");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TableContainer = /*#__PURE__*/(0, _styledComponents["default"])(_core.TableContainer).withConfig({
  displayName: "Table__TableContainer"
})(["max-height:", ";"], (0, _misc.pxToRem)(560));
var TableHead = /*#__PURE__*/(0, _styledComponents["default"])(_core.TableHead).withConfig({
  displayName: "Table__TableHead"
})(["", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      palette = _ref$theme.palette;
  return "\n    padding: ".concat(spacing(2, 2, 1, 2), ";\n    background-color: ").concat(palette.grey[50], ";\n  ");
});
var HeadingText = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).attrs({
  variant: 'body1'
}).withConfig({
  displayName: "Table__HeadingText"
})(["font-weight:bold;"]);
var Title = /*#__PURE__*/(0, _styledComponents["default"])(_core.Typography).withConfig({
  displayName: "Table__Title"
})(["", ""], function (_ref2) {
  var _ref2$theme = _ref2.theme,
      spacing = _ref2$theme.spacing,
      palette = _ref2$theme.palette;
  return "\n    padding: ".concat(spacing(2, 2, 0, 2), ";\n    background-color: ").concat(palette.grey[50], ";\n  ");
});

var Table = function Table(_ref3) {
  var title = _ref3.title,
      columns = _ref3.columns,
      rows = _ref3.rows,
      showPagination = _ref3.showPagination,
      rowsPerPageOptions = _ref3.rowsPerPageOptions,
      onActivateDemoVersion = _ref3.onActivateDemoVersion,
      props = _objectWithoutProperties(_ref3, ["title", "columns", "rows", "showPagination", "rowsPerPageOptions", "onActivateDemoVersion"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0, _react.useState)(rowsPerPageOptions[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      rowsPerPage = _useState4[0],
      setRowsPerPage = _useState4[1];

  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, rowsPerPageOptions[0]));
    setPage(0);
  };

  return _react["default"].createElement(_core.Paper, null, _react["default"].createElement(TableContainer, null, _react["default"].createElement(Title, {
    variant: "caption",
    color: "primary",
    component: "div"
  }, title), _react["default"].createElement(_core.Table, {
    stickyHeader: true
  }, _react["default"].createElement(TableHead, null, _react["default"].createElement(_core.TableRow, null, columns.map(function (column) {
    return _react["default"].createElement(_core.TableCell, {
      key: column.id,
      align: column.align,
      style: {
        minWidth: column.minWidth
      }
    }, _react["default"].createElement(HeadingText, null, column.label));
  }), _react["default"].createElement(_core.TableCell, {
    style: {
      minWidth: 100
    }
  }))), _react["default"].createElement(_core.TableBody, null, rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row) {
    return _react["default"].createElement(_core.TableRow, {
      hover: true,
      role: "checkbox",
      tabIndex: -1,
      key: row.id
    }, columns.map(function (column) {
      var value = row[column.id];
      return _react["default"].createElement(_core.TableCell, {
        key: column.id,
        align: column.align
      }, column.id === 'isActive' && value === true ? _react["default"].createElement(_atoms.Icon, {
        icon: "check",
        size: "small",
        color: "secondary",
        style: {
          paddingLeft: 15
        }
      }) : _react["default"].createElement(_core.Typography, {
        variant: "body1"
      }, column.format && typeof value === 'number' ? column.format(value) : value));
    }), _react["default"].createElement(_core.TableCell, {
      align: "right"
    }, _react["default"].createElement(_atoms.Button, {
      size: "small",
      color: "primary",
      onClick: function onClick() {
        return onActivateDemoVersion(row);
      },
      disabled: row['isActive']
    }, "Activate")));
  })))), showPagination && _react["default"].createElement(_core.TablePagination, {
    rowsPerPageOptions: rowsPerPageOptions,
    component: "div",
    count: rows.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onChangePage: handleChangePage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }));
};

Table.defaultProps = {
  rowsPerPageOptions: [10, 25, 100]
};
Table.propTypes = {
  title: _propTypes["default"].string,
  columns: _propTypes["default"].array,
  rows: _propTypes["default"].array,
  showPagination: _propTypes["default"].bool,
  rowsPerPageOptions: _propTypes["default"].array,
  onActivateDemoVersion: _propTypes["default"].func.isRequired
};
var _default = Table;
exports["default"] = _default;